export let hres6juColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }, {
    key: 'dtereq',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'numseq',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '65',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'status',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'remarkap',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '120',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codempap',
    name: '',
    labelCodapp: 'HRES6JUC1',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }]

  let tab1PopupTable1Columns = [{
    key: 'dteyear',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'year'
  }, {
    key: 'dtemonth',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '50',
    style: 'min-width: 100px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'codcours',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '70',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '80',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '90+100',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codinsts',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codinst',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '120',
    style: 'min-width: 200px;'
  }, {
    key: 'dateTraining',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '130',
    class: 'align-center',
    style: 'min-width: 240px;',
    headerRow: 1,
    colspan: 2,
    rowspan: 1
  }, {
    key: 'dtetrst',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '150',
    class: 'align-center',
    style: 'min-width: 120px;',
    headerRow: 2,
    colspan: 1,
    rowspan: 1,
    dataType: 'date'
  }, {
    key: 'qtytrhur',
    name: '',
    labelCodapp: 'HRESH6XC1',
    labelIndex: '160',
    class: 'align-center',
    style: 'min-width: 100px;'
  }]

  let tab1PopupTable2Columns = [{
    key: 'codsco',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codsco',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'dtestartf',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '40',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dteendf',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtecomm',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '60+70',
    class: 'align-center',
    style: 'min-width: 150px;',
    dataType: 'date'
  }, {
    key: 'qtymth',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '80+90',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'amtexp',
    name: '',
    labelCodapp: 'HRESH6XC2',
    labelIndex: '100',
    class: 'align-right',
    style: 'min-width: 100px;'
  }]

  let popupTrainingTableColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '60',
    style: 'min-width: 250px;'
  }, {
    key: 'dtemonth',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '70',
    style: 'min-width: 100px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'dtetrst',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'codinst',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '110',
    style: 'min-width: 200px;'
  }, {
    key: 'codhotel',
    name: '',
    labelCodapp: 'HRTR53C1',
    labelIndex: '120',
    style: 'min-width: 250px;'
  }]

  return {
    en: {
      index: indexColumns,
      tab1PopupTable1: tab1PopupTable1Columns,
      tab1PopupTable2: tab1PopupTable2Columns,
      popupTrainingTable: popupTrainingTableColumns
    },
    th: {
      index: indexColumns,
      tab1PopupTable1: tab1PopupTable1Columns,
      tab1PopupTable2: tab1PopupTable2Columns,
      popupTrainingTable: popupTrainingTableColumns
    }
  }
}

export let hres6juMaxRowspan = {
  popupDetail: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6ju.js